module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {}, [_c('div', {
    staticClass: "flex items-end"
  }, [_c('span', {
    staticClass: "f2 b title-responsive ml4-ns"
  }, [_vm._v(_vm._s(_vm.$t('titles.hi', {
    faq: 'Hi,'
  })) + " " + _vm._s(_vm.user.first_name))])]), _vm._v(" "), _c('div', {
    staticClass: "mv4-l mv2"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-wrap justify-evenly content"
  }, [_c('div', {
    staticClass: "w-30-l pa4 bg-white account-card mb4-l mb4-m pointer"
  }, [_c('router-link', {
    staticClass: "no-underline dib-ns",
    attrs: {
      "to": "/devices"
    }
  }, [_c('div', {
    staticClass: "responsive-card"
  }, [_c('div', {
    staticClass: "red-circle"
  }, [_vm._v("\n            " + _vm._s(this.devices.length) + "\n          ")]), _vm._v(" "), _c('img', {
    staticClass: "mr1 mb1",
    attrs: {
      "alt": "",
      "src": require("../../../static/appicons/yourStuff.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column justify-center text-responsive"
  }, [_c('div', {
    staticClass: "mb2 cera-round-pro-medium fw1"
  }, [_vm._v(_vm._s(_vm.$t('titles.stuff', {
    stuff: 'Your Stuff'
  })))]), _vm._v(" "), _c('span', {
    staticClass: "f6 inter"
  }, [_vm._v(_vm._s(_vm.itemsSubheader))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "w-30-l pa4 bg-white account-card mb4-l mb4-m mb0 pointer"
  }, [_c('router-link', {
    staticClass: "no-underline dib-ns",
    attrs: {
      "to": _vm.featureFlagRedirectClaimV2 ? '/claims-v2' : '/claims'
    }
  }, [_c('div', {
    staticClass: "responsive-card"
  }, [_c('div', {
    staticClass: "red-circle"
  }, [_vm._v("\n            " + _vm._s(this.claims.Open.length) + "\n          ")]), _vm._v(" "), _c('img', {
    staticClass: "mr1 mb1",
    attrs: {
      "alt": "",
      "src": require("../../../static/appicons/yourClaims.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column justify-center text-responsive"
  }, [_c('div', {
    staticClass: "mb2 cera-round-pro-medium fw1"
  }, [_vm._v(_vm._s(_vm.$t('titles.claims', {
    claims: 'Your Claims'
  })))]), _vm._v(" "), _c('span', {
    staticClass: "f6 inter"
  }, [_vm._v(_vm._s(_vm.claimsSubheader))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "w-30-l pa4 bg-white account-card mb4-l mb4-m mb0 pointer"
  }, [_c('router-link', {
    staticClass: "no-underline dib-ns",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_c('div', {
    staticClass: "responsive-card"
  }, [_c('div', {
    staticClass: "red-circle"
  }, [_c('img', {
    staticClass: "icon-account",
    attrs: {
      "alt": "",
      "src": require("../../../static/appicons/yourAccountCheck.svg")
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "mr1 mb1",
    attrs: {
      "alt": "",
      "src": require("../../../static/appicons/yourAccount.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column justify-center text-responsive"
  }, [_c('div', {
    staticClass: "mb2 cera-round-pro-medium fw1"
  }, [_vm._v(_vm._s(_vm.$t('titles.account', {
    account: 'Your Account'
  })))]), _vm._v(" "), _c('span', {
    staticClass: "f6 inter"
  }, [_vm._v("Information & Settings")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "w-30-l empty-card pa4 bg-white mb4-l mb4-m mb0 o1"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2f886e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/items.vue
// module id = 1289
// module chunks = 0